import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { planType } from '@utils/subscriptionCardOptions';

import Content from './Content';

interface SubscriptionLandingProps {
  highlightedOffer: planType;
  offerPlans: planType[];
}
const queryClient = new QueryClient();

const SubscriptionLanding = (props: SubscriptionLandingProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Content {...props} />
    </QueryClientProvider>
  );
};

export default SubscriptionLanding;
